import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";
import { callRejectionFacts, callRejectionV2Facts } from "../subjects/stopEvent/callRejectionFacts";

/**
 * The TMS took the call but could not auto-dispatch the driver onto their next load.
 *
 * One family for every reason the dispatch step fails: no preplan exists, the preplan is not active or names a
 * missing order, or no trailer is attached to dispatch with. The status fields say which.
 */
export const noAutoDispatchV1 = tmsEventKind(
  { category: "callRejection", kind: "noAutoDispatch", version: 1 },
  { refs: stopEventRefs, facts: callRejectionFacts },
);

export const NoAutoDispatchV1Schema = noAutoDispatchV1.schema;
export const NoAutoDispatchV1FactsSchema = noAutoDispatchV1.facts;

export type NoAutoDispatchV1 = z.infer<typeof NoAutoDispatchV1Schema>;
export type NoAutoDispatchV1Facts = z.infer<typeof NoAutoDispatchV1FactsSchema>;

/**
 * Version 2: the same refusal, plus what the driver's call said — its type, load, trailers, consignee, and lines.
 */
export const noAutoDispatchV2 = tmsEventKind(
  { category: "callRejection", kind: "noAutoDispatch", version: 2 },
  { refs: stopEventRefs, facts: callRejectionV2Facts },
);

export const NoAutoDispatchV2Schema = noAutoDispatchV2.schema;
export const NoAutoDispatchV2FactsSchema = noAutoDispatchV2.facts;

export type NoAutoDispatchV2 = z.infer<typeof NoAutoDispatchV2Schema>;
export type NoAutoDispatchV2Facts = z.infer<typeof NoAutoDispatchV2FactsSchema>;

/** Every version of `noAutoDispatch`, keyed by version. What `catalog.ts` places under `callRejection`. */
export const noAutoDispatch = { 1: noAutoDispatchV1, 2: noAutoDispatchV2 } as const;
